import { createContext, useCallback, useContext, useMemo, useRef, type ReactNode } from 'react';

type PayBillsHubContextValue = {
  registerRefetch: (refetch: () => void) => void;
  refetchBills: () => void;
};

const PayBillsHubContext = createContext<PayBillsHubContextValue | null>(null);

export const PayBillsHubProvider = ({ children }: { children: ReactNode }) => {
  const refetchRef = useRef<(() => void) | null>(null);

  const registerRefetch = useCallback((refetch: () => void) => {
    refetchRef.current = refetch;
  }, []);

  const refetchBills = useCallback(() => {
    refetchRef.current?.();
  }, []);

  const value = useMemo(
    () => ({ registerRefetch, refetchBills }),
    [registerRefetch, refetchBills]
  );

  return (
    <PayBillsHubContext.Provider value={value}>{children}</PayBillsHubContext.Provider>
  );
};

export const usePayBillsHub = () => {
  const context = useContext(PayBillsHubContext);
  if (!context) {
    throw new Error('usePayBillsHub must be used within PayBillsHubProvider');
  }
  return context;
};

export const usePayBillsHubOptional = () => useContext(PayBillsHubContext);
